<template>
    <v-dialog :value="value" max-width="900px" scrollable :persistent="persistent" @keydown.esc.prevent="cancel">
        <v-card max-height="var(--dialog-height)">
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
            </v-card-title>

            <v-card-text>
                <DependencyView v-bind="$attrs" v-on="$listeners" />
            </v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';
import DependencyView from '@/components/DependencyView.vue';

export default {
    name: 'DependencyDialog',
    components: {
        DependencyView,
    },

    props: {
        title: {
            type: String,
            default: () => i18n().t('dependencies'),
        },
        persistent: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {};
    },

    methods: {
        cancel() {
            this.$emit('cancel');
            this.$emit('input', false);
        },
    },
};
</script>
